import { HttpClient } from '@angular/common/http';
import { Component, OnInit, AfterViewInit, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AuthenticationService, InventarioService, ProductoService } from '../../_services';
import { MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProductosDialogBundle } from '../productos/productos.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {merge, Observable, of as observableOf, Subject}  from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { CanalService } from 'src/app/_services/canal.service';
import { DialogoConfirmacionComponent } from "../dialogo-confirmacion/dialogo-confirmacion.component";
import { environment } from 'src/environments/environment';

interface Canales {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-canales',
  templateUrl: './canales.component.html',
  styleUrls: ['./canales.component.scss']
})
export class CanalesComponent implements OnInit {

  edit_item: any = null;
  selected_tab: number = 0;
  current_user: any;

  constructor( private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.asignarDatos();
  }

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  tabClick(event){
    this.selected_tab = event.index;
    if (this.selected_tab != 1){
      this.edit_item = null;
    }
  }

}

@Component({
  selector: 'canales-tab-1',
  templateUrl: './canales-tab-1.html',
  styleUrls: ['./canales.component.scss']

})
export class CanalesTab1 implements AfterViewInit {

  canal: FormControl =  new FormControl('', []);

  canales: Canales[] = [
    {value: 'Amazon', viewValue: 'Amazon'},
    {value: 'Coppel', viewValue: 'Coppel'},
    {value: 'Liverpool', viewValue: 'Liverpool'},
    {value: 'Shopify', viewValue: 'Shopify'},
    {value: 'MercadoLibre', viewValue: 'MercadoLibre'},
    {value: 'Elenas', viewValue: 'Elenas'},
    {value: 'Odoo', viewValue: 'Odoo'},
    {value: 'Walmart', viewValue: 'Walmart'},
  ];

  displayedColumns: string[] = [
                                  'canal',
                                  'title',
                                  'sku', 
                                  'ean',
                                  'item_match',
                                  'actions',
                                  'publicaciones'
                                ];
  productoDatabase: ProductoDatabase | null;
  data: Productos[] = [];

  resultsLength      = 0;
  isLoadingResults   = true;
  isRateLimitReached = false;
  guiaForm           : FormGroup;
  keywords           = "";
  formBO             : FormControl;
  spinner            = false;
  hay_datos          = true; 
  titulo_diff        = false;
  datos_iniciales    = true;
  current_user       : any


  constructor(
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private inventarioService: InventarioService,
      private productoService: ProductoService,
      private canalService: CanalService,
      private snackBar: MatSnackBar,
      private router: Router,
      private canalesComponent: CanalesComponent,
      private authenticationService: AuthenticationService
  ) { 
  }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngAfterViewInit() {


    this.productoDatabase = new ProductoDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);
    this.formBO = new FormControl('', [ ]);


  }

  applyFilterFulfillment(){
    this.hacerTabla(this.keywords);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.productoDatabase!.getProductos(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords, this.canal.value);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false 
            this.datos_iniciales = false
          }else{
            this.hay_datos = true 
            this.datos_iniciales = true
          }
         

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTabla(this.keywords);
  }

  onChange(value, item_id) {
    this.spinner = true;
    // console.log(value);
    // console.log(item_id);
    this.inventarioService.cambiarBackOrder(item_id, value)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data["message"][0]);
        this.spinner = false;
        this.snackBar.open(data["message"][0], "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
    });
  }

  openProductosDetalle(item){
    this.productoService.consultarProducto(item.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogProductosDetalle = this.dialog.open(CanalesDetalle ,{ width:'90vw', height: '90%',disableClose: false ,data: {item: data.body.item, files: data.body.files, inventario_scrap: data.body.inventario_scrap} });
          
            //Listener para detectar click en el enditar producto
            const dialogEditSubscription = dialogProductosDetalle.componentInstance.editClicked
            .subscribe(item_id => {
              this.canalesComponent.edit_item = item_id;
              this.canalesComponent.selected_tab = 1;
              dialogEditSubscription.unsubscribe();
            });
          }
        },
      error => {
    });
  }

  alertAgregarItem(product){
    let validar_match_by = this.validarMatchBy(product);

    if (!validar_match_by) {
      this.snackBar.open(`No se puede crear Producto en Marketful porque la publicación no tiene ${product.match_product_by}`, "ERROR", {                      
        duration: 10000,
        panelClass: ['red-snackbar']
      });
      return false;
    }

    const dialogConfirmCreateItem = this.dialog.open(CanalesDialogConfirmCreateItem ,{ width:'40vw', height: '41%',disableClose: false ,data: {product: product} });
    dialogConfirmCreateItem.afterClosed().subscribe(result => {
      if(result){
        this.hacerTabla(this.keywords);
      }
    });
  }

  alertEliminarRelacionItem(product){
    this.dialog
      .open(DialogoConfirmacionComponent, {
        data: {pregunta: '¿Eliminar relación de Publicación con Producto de Marketful?', mensaje: ''}
      }).afterClosed().subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.spinner = true;
          this.canalService.eliminarRelacionarPublicacionConItem(product.id)
            .pipe(first())
            .subscribe(
              data => {
                  this.spinner = false;
                  if(data.result == "OK"){
                    this.hacerTabla(this.keywords);
                    this.snackBar.open(data.message, "OK", {                      
                      duration: 3500,
                    });
                  }else{
                    this.snackBar.open(data.message, "ERROR", {                      
                      duration: 10000,
                      panelClass: ['red-snackbar']
                    });
                  }
                },
              error => {
              });
        }
      });
  }

  alertLigarProductoItem(product){
    let validar_match_by = this.validarMatchBy(product);

    if (!validar_match_by) {
      this.snackBar.open(`No se puede relacionar con Producto de Marketful porque la publicación no tiene ${product.match_product_by}`, "ERROR", {                      
        duration: 10000,
        panelClass: ['red-snackbar']
      });
      return false;
    }

    const dialogConfirmCreateItem = this.dialog.open(CanalesDialogLigarProductoItem ,{ width:'60vw',disableClose: false ,data: {product: product} });
    dialogConfirmCreateItem.afterClosed().subscribe(result => {
      if(result){
        this.hacerTabla(this.keywords);
      }
    });
  }

  //Verificar match_by
  validarMatchBy(product) {
    let match_product_by = product.match_product_by;

    let se_puede_ligar = true;

    if (match_product_by == "SELLER_SKU" || match_product_by == "SKU") {
      if(product.seller_sku == null || product.seller_sku == ''){
        se_puede_ligar = false;
      }
    }else if(match_product_by == "EAN"){
      if(product.ean == null || product.ean == ''){
        se_puede_ligar = false;
      }
    }

    return se_puede_ligar
  }

  openPublicaciones(product){
    this.canalService.consultarProducto(product.id)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            const dialogProductosDetalle = this.dialog.open(CanalesPublicaciones ,{ width:'90vw', height: '90%',disableClose: false ,data: {publicaciones: data.body.publicaciones, item_master: data.body.item_master} });
          
            //Listener para detectar click en el enditar producto
            const dialogEditSubscription = dialogProductosDetalle.componentInstance.editClicked
            .subscribe(product_id => {
              this.canalesComponent.edit_item = product_id;
              this.canalesComponent.selected_tab = 1;
              dialogEditSubscription.unsubscribe();
            });
          }
        },
      error => {
    });
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

}

export class ProductoDatabase {
  constructor(private _httpClient: HttpClient) {}

  getProductos(sort: string, order: string, page: number, filtro: string, canal: string): Observable<EntradabApi> {
     const href = `${environment.apiUrl}/products.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&nombre_producto=${filtro}&canal=${canal}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}

export interface Productos {
  created_at: string;
  number: string;
  state: string;
  title: string;
  seller_sku: string;
  ean: string;
}

@Component({
  selector: 'canales-publicaciones',
  templateUrl: './canales-publicaciones.html',
  styleUrls: ['./canales.component.scss']

})

export class CanalesPublicaciones implements OnInit {

  @Output() editClicked = new EventEmitter<any>();

  publicaciones: [];
  item_master: Productos;
  spinner = false;
  current_user: any;

  constructor(public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    public dialogRef: MatDialogRef<CanalesDetalle>,
    private inventarioService: InventarioService,
    private productoService: ProductoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.publicaciones = this.data.publicaciones;
      this.item_master = this.data.item_master;
    }
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  openDialogEntrada(item_id, seller_sku, titulo){
    // Hacer request para consular el bundle y que responda como
    // render {items => los componentes del bundle que venga (sku, producto, cantidad) }
    // DESCOMENTAR CUANDO ESTE EL REUQEST LISTO
    this.inventarioService.consultarBundle(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Bundle es");
        // console.log(data);
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
        }
      },
      error => {
    });

    // Quitar cuando ya se tenga el request
    // let data = {items: []} // Comentar cuando ya se tenga el request
    // const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
  }

  getMarketplaceListingId(publicacion) {
    let marketplace_listing_id = '';
    switch (publicacion.canal.toLowerCase()) {
      case 'liverpool':
          marketplace_listing_id = (publicacion.liverpool_offer_id != null) ? publicacion.liverpool_offer_id : '';
        break;
      case 'elenas':
          marketplace_listing_id = (publicacion.elena_id != null) ? publicacion.elena_id : '';
        break;
      case 'mercadolibre':
          marketplace_listing_id = (publicacion.ml_id != null) ? publicacion.ml_id : '';
        break;
      case 'odoo':
          marketplace_listing_id = (publicacion.odoo_product_id != null) ? publicacion.odoo_product_id : '';
        break;
    
      default:
          marketplace_listing_id = (publicacion.offer_id != null) ? publicacion.offer_id : '';
        break;
    }

    return marketplace_listing_id;
  }

}

@Component({
  selector: 'canales-detalle',
  templateUrl: './canales-detalle.html',
  styleUrls: ['./canales.component.scss']

})

export class CanalesDetalle implements OnInit {

  @Output() editClicked = new EventEmitter<any>();

  item: any;
  files: any;
  inventario_scrap: any;
  spinner = false;
  current_user: any;

  constructor(public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    public dialogRef: MatDialogRef<CanalesDetalle>,
    private inventarioService: InventarioService,
    private productoService: ProductoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.item = this.data.item;
      this.files = this.data.files;
      this.inventario_scrap = this.data.inventario_scrap;
    }
  }

  ngOnInit() {
    this.asignarDatos(); 
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  showEtiqueta(item_id, seller_sku){
    if(seller_sku != ""){
      this.spinner = true
      this.inventarioService.getEtiqueta(item_id, seller_sku)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          if(data.status == 200){
            if(data.body["se_puede"] == true){
              window.open(data.body["status"], "_blank");
              this.spinner = false
            }else{
              this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {                      
                duration: 5000,
              });
              this.spinner = false
            }
          }else{
            this.snackBar.open("Ocurrio un error al generar la etiqueta", "OK", {                      
              duration: 5000,
            });
            this.spinner = false
          }
        },
        error => {
      });
    }else{
      this.snackBar.open("El producto debe tener un SKU menor o igual a 15 caracteres.", "OK", {                      
        duration: 5000,
      });
    }
  }

  editarPorducto(item_id){
    this.editClicked.emit(item_id);
    this.dialogRef.close();
  }

  confirmarEliminarProducto(item_id){
    const dialogRef1 = this.dialog.open(ProductosDialog1, {width:'450px', height: 'auto',disableClose: true});

    dialogRef1.afterClosed().subscribe(result => {
      if (result == true){
        this.eliminarPorducto(item_id);
      }
    });
  }

  eliminarPorducto(item_id){
    this.spinner = true;
      this.productoService.eliminarPorducto(item_id)
      .pipe(first())
      .subscribe(
        data => {
          if (data["status"] == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/productos']);
            });
          }
          this.snackBar.open(data["message"], "OK", {                      
            duration: 7500,
          });
         this.spinner = false;
         this.dialogRef.close();
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Hubo un error al eliminar el producto", "OK", {                      
            duration: 7500,
          });
     });
  }

  openDialogEntrada(item_id, seller_sku, titulo){
    // Hacer request para consular el bundle y que responda como
    // render {items => los componentes del bundle que venga (sku, producto, cantidad) }
    // DESCOMENTAR CUANDO ESTE EL REUQEST LISTO
    this.inventarioService.consultarBundle(item_id)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Bundle es");
        // console.log(data);
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
        }
      },
      error => {
    });

    // Quitar cuando ya se tenga el request
    // let data = {items: []} // Comentar cuando ya se tenga el request
    // const dialogRef3 = this.dialog.open(ProductosDialogBundle ,{ width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller_sku: seller_sku, titulo: titulo, item_id: item_id} });
  }

}

@Component({
  selector: 'canales-dialog-ligar-producto-item',
  templateUrl: './canales-dialog-ligar-producto-item.html',
  styleUrls: ['./canales.component.scss']

})

export class CanalesDialogLigarProductoItem implements OnInit {

  displayedColumns: string[] = ['title', 'seller_sku', 'ean', 'accion'];
  items: Productos[] = [];
  product: any;
  spinner = false;
  filtro = null;

  constructor(public dialog: MatDialog,
    private canalService: CanalService,
    public dialogo: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CanalesDetalle>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.product = this.data.product;
    }
  }

  ngOnInit() {
    
  }

  buscarItem(){
    if( this.filtro == null || this.filtro == ""){
      this.snackBar.open("Debe ingresar el Nombre, SKU o EAN del Producto", "OK", {                      
        duration: 3500,
      });
    }else{
      this.canalService.buscarItem(this.filtro)
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            this.items = data.body.items;
          }
        },
      error => {
    });
    }
  }

  confirmarLigarPublicacion(item): void {
    this.dialogo
      .open(DialogoConfirmacionComponent, {
        data: {pregunta: '¿Relacionar Publicación con Producto?', mensaje: ''}
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.spinner = true;
          this.canalService.relacionarPublicacionConItemExistente(this.product.id, item.id)
            .pipe(first())
            .subscribe(
              data => {
                  this.spinner = false;
                  if(data.result == "OK"){
                    this.dialogRef.close(true);
                    this.snackBar.open(data.message, "OK", {                      
                      duration: 3500,
                    });
                  }else{
                    this.snackBar.open(data.message, "ERROR", {                      
                      duration: 10000,
                      panelClass: ['red-snackbar']
                    });
                  }
                },
              error => {
              });
        }
      });
  }
}

@Component({
  selector: 'canales-dialog-confirm-create-item',
  templateUrl: './canales-dialog-confirm-create-item.html',
  styleUrls: ['./canales.component.scss']

})

export class CanalesDialogConfirmCreateItem implements OnInit {

  product: any;
  ean_duplicado = false;
  seller_sku_duplicado = false;
  item_con_ean_duplicado =  null;
  spinner = false;
  item_duplicado = false;

  constructor(public dialog: MatDialog,
    private canalService: CanalService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CanalesDetalle>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    if(this.data){
      this.product = this.data.product;
    }
  }

  ngOnInit() {
    
  }

  crearItem(){
    this.spinner = true;
    this.canalService.crearItem(this.product.id)
        .pipe(first())
        .subscribe(
          data => {
              this.spinner = false;
              if(data.result == "OK"){
                this.dialogRef.close(true);
                this.snackBar.open(data.message, "OK", {                      
                  duration: 3500,
                });
              }else if(data.result == "ERROR-EAN-DUPLICADO" || data.result == "ERROR-SELLER_SKU-DUPLICADO"){
                if(data.result == "ERROR-EAN-DUPLICADO" ){
                  this.ean_duplicado = true;
                }else{
                  this.seller_sku_duplicado = true;
                }

                this.item_duplicado = true;
                
                this.item_con_ean_duplicado = data.item;
                this.snackBar.open(data.message, "ERROR", {                      
                  duration: 10000,
                  panelClass: ['red-snackbar']
                });
              }
              else{
                this.snackBar.open(data.message, "ERROR", {                      
                  duration: 10000,
                  panelClass: ['red-snackbar']
                });
              }
            },
          error => {
          });
  }

  relacionarConItemExistente(){
    this.spinner = true;
    this.canalService.relacionarPublicacionConItemExistente(this.product.id, this.item_con_ean_duplicado.id)
      .pipe(first())
      .subscribe(
        data => {
            this.spinner = false;
            if(data.result == "OK"){
              this.dialogRef.close(true);
              this.snackBar.open(data.message, "OK", {                      
                duration: 3500,
              });
            }else{
              this.snackBar.open(data.message, "ERROR", {                      
                duration: 10000,
                panelClass: ['red-snackbar']
              });
            }
          },
        error => {
        });
  }
}

export class ProductosDialog1 {}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
  available_quantity: number;
}

export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface EntradabApi {
  items: Productos[];
  total_count: number;
}
